module.exports = __webpack_public_path__ + "e611261a2796b202359c6d8bf69f10dc.svg";